import "babel-polyfill";
import axios from "axios";
import verge from "verge";
// import { Validation } from "bunnyjs/src/Validation";

import "./css/styles.scss";
import "./img/logo.svg";
import "./img/slant.svg";
import "./img/great-kids.jpg";
import "./img/quote-child.jpg";
import "./img/video-section-bg.png";

// pdf
import "./pdf/PCG_TItle1SalesSheet_1.pdf";

// icons
import "./img/Quotesymbol.svg";
import "./img/Alerts.svg";
import "./img/Backtotopcarat.svg";
import "./img/Contact-Callus.png";
import "./img/Contact-Salessheet.svg";
import "./img/Contact-Salessheet-blue.svg";
import "./img/Contact-Ticket.svg";
import "./img/Copyright.svg";
import "./img/Dashboards.svg";
import "./img/Datasecurity.svg";
import "./img/Datastorage.svg";
import "./img/DLsalessheet.svg";
import "./img/Fileformats.svg";
import "./img/Help.svg";
import "./img/logo.svg";
import "./img/Playbutton.svg";
import "./img/slant.svg";
import "./img/Users.svg";
import "./img/Workflows.svg";
import "./img/icons_ex.svg";

class LoginPage {
  constructor() {
    this.mainHeader = document.getElementById("mainHeader");
    this.nav = document.getElementById("navWrapper");
    this.hamburger = document.getElementById("ham");
    this.slingers = document.querySelectorAll(".slingshot");
    this.loginPopOver = document.getElementById("logInPopOver");
    this.cards = document.querySelectorAll("#featureWrapper .card");
  }

  // sets up click listeners for the whole page
  setupClicks() {
    this.hamburger.addEventListener("click", e => this.toggleNav(e));
    [...this.slingers].forEach(slinger => {
      slinger.addEventListener("click", e => this.scrollToContent(e));
    });
  }

  toggleNav(e) {
    e.preventDefault();

    this.mainHeader.classList.toggle("active");
    this.nav.classList.toggle("expanded");
    this.hamburger.classList.toggle("open");

    if (!this.nav.classList.contains("expanded")) {
      this.loginPopOver.classList.remove("shown");
    }
  }

  prepContactFormContent(e) {
    e.preventDefault();

    const form = document.getElementById("contactForm");
    const formBtn = document.querySelector("#contactForm .btn");
    formBtn.setAttribute("disabled", "disabled");

    const json = this.toJSONString(form, true);
    // console.log(json);

    this.submitContact(json);
  }

  prepLogInFormContent(e) {
    e.preventDefault();

    const form = document.getElementById("logInForm");
    const formBtn = document.querySelector("#logInForm .btn");
    formBtn.setAttribute("disabled", "disabled");

    const json = this.toJSONString(form);
    // console.log(json);

    this.submitLogIn(json);
  }

  prepContactForm() {
    const contactForm = $("#contactForm");
    const validatedContactForm = contactForm.parsley();

    contactForm.submit(e => {
      e.preventDefault();
      if (contactForm.parsley().isValid()) {
        this.prepContactFormContent(e);
      }
    });
  }

  prepLogInForm() {
    const loginForm = $("#logInForm");
    const validatedLoginForm = loginForm.parsley();

    loginForm.submit(e => {
      e.preventDefault();
      if (loginForm.parsley().isValid()) {
        this.prepLogInFormContent(e);
      }
    });
  }

  toJSONString(form, getFunnelId = false) {
    let obj = {};
    const elements = form.querySelectorAll("input, textarea");

    [...elements].forEach(element => {
      let name = element.name;
      let value = element.value;

      if (name) {
        obj[name] = value;
      }

      if (getFunnelId) {
        const funnelId = getCookie("entryId");
        obj["MethodId"] = parseInt(funnelId);
      }
    });

    return obj;
  }

  submitLogIn(payload) {
    // the fake one
    // const endopint = "https://reqres.in/api/login";

    // The real one
    const endpoint = "/Account/Login";
    $("#logInForm p.error").remove();

    $.ajax({
      method: "POST",
      url: endpoint,
      data: payload,
      success: function(data) {
        // console.log(data);

        if (data.Success) {
          // reload the page
          window.location.replace("/Account/Login");
        } else {
          // console.log("bad jorb, charlie");
          const submitBtn = document.querySelector("#logInForm .btn");
          submitBtn.removeAttribute("disabled");

          const errorMsg = document.createElement("p");
          errorMsg.classList.add("error");
          errorMsg.innerText = "Invalid username and/or password";

          $(errorMsg).insertBefore(submitBtn);
        }
      },
      error: function(xhr, status, errorThrown) {
        // what to do....?
        console.log(errorThrown);
        console.log(xhr.status);

        const submitBtn = document.querySelector("#logInForm .btn");
        const loginForm = document.querySelector("#logInForm");

        const errorMsg = document.createElement("p");
        errorMsg.classList.add("error");

        if (xhr.status == 404 || xhr.status == 500) {
          errorMsg.innerText = "Server Error.";
        } else {
          errorMsg.innerText = "Something went wrong.";
        }
        $(errorMsg).insertBefore(submitBtn);
      }
    });
  }

  submitContact(payload) {
    // the fake one
    // const endopint = "https://reqres.in/api/users";

    // The real one
    const endopint = "/Contact/Create";

    $.ajax({
      method: "POST",
      url: endopint,
      data: payload,
      success: function(data) {
        // console.log(data);

        if (data.Success) {
          // say thank you
          deleteCookie("entryId");

          const leftCol = document.querySelector(".bigBox .left");
          leftCol.classList.add("collapse");

          const contactForm = document.getElementById("contactForm");
          contactForm.classList.add("done");

          const thanksMsg = document.getElementById("thanks");
          thanksMsg.classList.add("active");
        } else {
          const submitBtn = document.querySelector("#contactForm .btn");
          submitBtn.removeAttribute("disabled");
        }
      }
    });
  }

  setupContactEntryPoints() {
    const entryButtons = document.querySelectorAll(".contact-entry");
    [...entryButtons].forEach(entryButton => {
      entryButton.addEventListener("click", e => this.setContactEntryPoint(e));
    });
  }

  setContactEntryPoint(e) {
    const entryId = e.currentTarget.getAttribute("data-funnel");
    setCookie("entryId", entryId);
  }

  scrollToContent(event) {
    event.preventDefault();
    const target = event.currentTarget.getAttribute("data-target");
    const offset = event.currentTarget.getAttribute("data-offset");
    const elem = document.getElementById(target);
    const targetPosition =
      elem.getBoundingClientRect().top - parseInt(offset) + window.pageYOffset;

    $("html, body").animate(
      {
        scrollTop: targetPosition
      },
      550
    );
  }

  toggleLogIn(e) {
    e.preventDefault();

    this.loginPopOver.classList.toggle("shown");
    this.setUsernameFocus();
  }

  setupLoginTip() {
    const logInBtn = document.getElementById("logInBtn");
    logInBtn.addEventListener("click", e => this.toggleLogIn(e));
  }

  setUsernameFocus() {
    document.querySelector("input[name='email']").focus();
  }

  compareCardHeights() {
    const efficientCardResize = debounce(function() {
      const cards = document.querySelectorAll("#featureWrapper .card");

      // reset the card heights
      [...cards].forEach(card => {
        card.style.minHeight = "0px";
        console.log(card.style.minHeight);
      });

      if (verge.viewportW() >= 732) {
        // set the card heights
        let definition = false;

        [...cards].forEach(card => {
          if (!definition) {
            definition = card;
          }

          if (card.clientHeight > definition.clientHeight) {
            definition = card;
          }
        });

        [...cards].forEach(card => {
          card.style.minHeight = `${definition.clientHeight}px`;
        });
      }
    }, 300);

    window.addEventListener("resize", efficientCardResize);
  }

  resetCardHeights() {
    [...this.cards].forEach(card => {
      card.style.minHeight = "0px";
      console.log(card.style.minHeight);
    });
  }

  setCardHeights() {
    if (verge.viewportW() >= 732) {
      // set the card heights
      let definition = false;

      [...this.cards].forEach(card => {
        if (!definition) {
          definition = card;
        }

        if (card.clientHeight > definition.clientHeight) {
          definition = card;
        }
      });

      [...this.cards].forEach(card => {
        card.style.minHeight = `${definition.clientHeight}px`;
      });
    }
  }

  setup() {
    this.setupClicks();
    this.setupLoginTip();
    this.prepContactForm();
    this.prepLogInForm();
    this.setupContactEntryPoints();
    this.compareCardHeights();
    this.setCardHeights();
  }
}

const setCookie = (name, value, days = 1, path = "/") => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie =
    name +
    "=" +
    encodeURIComponent(value) +
    "; expires=" +
    expires +
    "; path=" +
    path;
};

const getCookie = name => {
  return document.cookie.split("; ").reduce((r, v) => {
    const parts = v.split("=");
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, "");
};

const deleteCookie = (name, path = "/") => {
  setCookie(name, "", -1, path);
};

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    const context = this,
      args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

document.addEventListener("DOMContentLoaded", () => {
  const loginPage = new LoginPage();
  loginPage.setup();
});



// WEBPACK FOOTER //
// ./login.js